// import {article,projectConf,question,subject,user} from "./api"
import article from "./api/article.json"
import projectConf from "./api/projectConf.json"
import question from "./api/question.json"
import subject from "./api/subject.json"
import user from "./api/user.json"
const url_file = {
    "sign/getConf":"getProjectConf",
    'sign/selectSubject':'getSubject',
    'sign/selectArticle':'getArticle',
    'sign/selectLoginArticle':'getArticle',
    'article/select':'getArticle',
    'sign/in':"login",
    'question/select':"getQuestion"

}

class staticRequest{
    post(url, data){
        return new Promise((resolve)=>{
            let mds = url_file[url];
            mds = mds?mds:'other';
            return resolve(this[mds](data))
        })
        
    }
    //获取基本配置
    getProjectConf(){
        return {flag:1,data:projectConf};
    }
    //获取科目
    getSubject(){
        return {flag:1,data:subject};
    }
    //获取文本内容
    getArticle(data){
        var articles = article.filter(item=>{
            return item.classify == data.classify
        });
        return {flag:1,data:{articles:articles}};
    }
    //登陆
    login(data){
        var flag = false;
        var items = {};
        user.map(item=>{
            let true_len = 0;
            for(let i in data){
                if(data[i] == item[i]){
                    true_len += 1
                }
            }
            if(true_len == Object.keys(data).length ){
                flag = true;
                items = item;
            }
        })
        return {flag:flag?1:0,msg:flag?"登录成功":"登录失败，账户信息不匹配",data:{user_id:items.user_id,token:"static"+(new Date()).getTime()}}
    }
    //获取试卷
    getQuestion(data){
        return {flag:1,data:question[data.paper_id]}
    }

    other(){
        return {flag:1}
    }
}

export default new staticRequest()